import { createAction, props } from '@ngrx/store';

import { ClientCreateModel } from '@lockton-apps/client-gateway/interfaces';

import { ClientUpdateActionTypes } from './types';

export const clientUpdated = createAction(
  ClientUpdateActionTypes.ClientUpdated,
  props<{ clientModel: ClientCreateModel }>()
);
